import axios from 'axios'
import { Message } from 'element-ui'
import router from '@/router'

// 创建 axios 实例
const service = axios.create({
  baseURL: '',  // 使用空字符串，让请求使用相对路径
  timeout: 30000,
  retry: 3,
  retryDelay: 2000,
  withCredentials: true,  // 确保跨域请求发送cookies
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'X-Requested-With': 'XMLHttpRequest'
  }
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 添加认证信息 - 保留token逻辑以备将来使用
    const token = localStorage.getItem('token')
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }
    
    // 添加时间戳防止缓存
    if (config.method === 'get') {
      config.params = {
        ...config.params,
        _t: Date.now()
      }
    }

    // 打印请求信息，方便调试
    console.log('Request:', {
      url: config.url,
      method: config.method,
      headers: config.headers,
      params: config.params,
      data: config.data
    })
    
    return config
  },
  error => {
    console.error('Request Error:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    console.log('Response:', response)
    
    // 检查响应中是否有自定义错误码
    if (response.data && response.data.code === 401) {
      // 判断当前路由是否为公开页面（如博客文章页）
      const isPublicRoute = router.currentRoute.matched.some(record => record.meta.public)

      // 仅在非公开页面时才跳转到登录页
      if (!isPublicRoute) {
        // 会话过期，跳转到登录页
        router.push('/login')
        Message.error(response.data.message || '登录已过期，请重新登录')
      }

      return Promise.reject(new Error(response.data.message || '登录已过期'))
    }
    
    // 如果响应成功，返回响应数据
    return response.data
  },
  error => {
    console.error('Response Error:', error)
    
    if (error.response) {
      // 服务器返回了错误状态码
      console.error('Error Status:', error.response.status)
      console.error('Error Data:', error.response.data)
      
      if (error.response.status === 401) {
        // 判断当前路由是否为公开页面（如博客文章页）
        const isPublicRoute = router.currentRoute.matched.some(record => record.meta.public)

        // 仅在非公开页面时才跳转到登录页
        if (!isPublicRoute) {
          // 未授权，跳转到登录页
          router.push('/login')
          Message.error(error.response.data?.message || '登录已过期，请重新登录')
        }
      } else {
        Message.error(error.response.data?.message || '请求失败')
      }
    } else if (error.request) {
      // 请求已发出，但没有收到响应
      console.error('No Response:', error.request)
      Message.error('服务器无响应，请检查网络连接')
    } else {
      // 请求配置出错
      console.error('Request Config Error:', error.message)
      Message.error('请求配置错误')
    }
    
    return Promise.reject(error)
  }
)

export default service 